export const TeksBody = {
    code: '',
    accuracy: 0,
    corrects: 0,
    incorrect: 0,
    total: 0,
};
